import {
  TEXT_FIELD_ICON_CLASS_NAME,
  DEFAULT_ICON_CLASS_NAME,
  SECONDARY_ICON_CLASS_NAME,
  NAVBAR_ICON_CLASS_NAME,
} from '../../constants/icon';
import FingoMuiSvgIcon from '../../fingo/components/MuiIcon';

const textFieldIcon = ({ theme }) => ({
  color: theme.palette.primary.A300,
});

const defaultIcon = ({ theme }) => ({
  color: theme.palette.secondary.A400,
});

const secondaryIcon = ({ theme }) => ({
  color: theme.palette.secondary.A300,
});

const MuiIcon = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiSvgIcon.styleOverrides.root({ theme }),
      [`&.${TEXT_FIELD_ICON_CLASS_NAME}`]: textFieldIcon({ theme }),
      [`&.${DEFAULT_ICON_CLASS_NAME}`]: defaultIcon({ theme }),
      [`&.${SECONDARY_ICON_CLASS_NAME}`]: secondaryIcon({ theme }),
      [`&.${NAVBAR_ICON_CLASS_NAME}`]: {
        color: theme.palette.common.white,
        fontSize: 24,
      },
    }),
  },
};

export default MuiIcon;
